import React from "react";
import { AppBar } from "@mui/material";
import { useSelector } from "react-redux";
import { NavbarMobile } from "./NavbarMobile/NavbarMobile";
import { NavbarDesktop } from "./NavbarDesktop/NavbarDesktop";
import { useMobile } from "../../Hooks/useMobile";
import "./Navbar.scss";

/**
 * Navbar component que renderiza la barra de navegación sticky.
 * Detecta automáticamente el tipo de dispositivo y estado de autenticación
 * para mostrar la versión mobile o desktop correspondiente.
 *
 * @returns {JSX.Element} AppBar con navbar responsive y cintillo decorativo
 */
export const Navbar = () => {
  const isMobile = useMobile();
  const { authUser } = useSelector((state) => state.auth);
  const isAuthenticated = authUser && authUser.idUsuario > 0;

  return (
    <AppBar position="sticky" className="custom-navbar" elevation={0}>
      {isMobile ? (
        <NavbarMobile isAuthenticated={isAuthenticated} />
      ) : (
        <NavbarDesktop isAuthenticated={isAuthenticated} />
      )}
      <div className="custom-navbar__cintillo" />
    </AppBar>
  );
};
